import { useEffect, useState } from "react";

function pad(n) {
    return String(n).padStart(2, "0");
}

export default function Countdown({ target }) {
    // target ISO string
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);
    if (!target) return null;
    const end = new Date(target).getTime();
    let diff = Math.max(0, end - now);
    const days = Math.floor(diff / 86400000);
    diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const mins = Math.floor(diff / 60000);
    diff -= mins * 60000;
    const secs = Math.floor(diff / 1000);
    const box = "flex flex-col items-center bg-white/10 border border-brand-goldLight/30 rounded-xl px-3 md:px-4 py-2 md:py-3 min-w-[64px]";
    return (
        <div data-testid="countdown" className="flex items-center gap-2 md:gap-3">
            <div className={box}>
                <span className="text-2xl md:text-3xl font-bold text-brand-goldLight tabular-nums">{pad(days)}</span>
                <span className="text-[10px] uppercase tracking-widest text-white/60 mt-1">Days</span>
            </div>
            <span className="text-brand-goldLight text-xl font-bold">:</span>
            <div className={box}>
                <span className="text-2xl md:text-3xl font-bold text-brand-goldLight tabular-nums">{pad(hours)}</span>
                <span className="text-[10px] uppercase tracking-widest text-white/60 mt-1">Hrs</span>
            </div>
            <span className="text-brand-goldLight text-xl font-bold">:</span>
            <div className={box}>
                <span className="text-2xl md:text-3xl font-bold text-brand-goldLight tabular-nums">{pad(mins)}</span>
                <span className="text-[10px] uppercase tracking-widest text-white/60 mt-1">Min</span>
            </div>
            <span className="text-brand-goldLight text-xl font-bold">:</span>
            <div className={box}>
                <span className="text-2xl md:text-3xl font-bold text-brand-goldLight tabular-nums">{pad(secs)}</span>
                <span className="text-[10px] uppercase tracking-widest text-white/60 mt-1">Sec</span>
            </div>
        </div>
    );
}
